import type { TypedStartListening } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";

import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";
import { fetchArgusQuery } from "@mnemonic/redux-utils";
import type { IArgusQueryMeta } from "@mnemonic/redux-utils";

import type { IExtraThunkArgs, TAppDispatch, TAppState } from "../createStore";

const tagTypes = ["AuthenticationData", "AuthorizationData"] as const;
export type TBaseApiTagTypes = (typeof tagTypes)[number];

export type TMetaOpts = {
  notifyOn412?: boolean;
  [x: string]: unknown;
};

export type TAppStartListening = TypedStartListening<TAppState, TAppDispatch, IExtraThunkArgs>;

export interface IMeta extends IArgusQueryMeta<TMetaOpts> {}

export interface IBaseApiParams<TCriteria> {
  criteria: TCriteria;
  metaOpts?: TMetaOpts;
}

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fetchArgusQuery({
    baseUrl: ArgusUtils.getApiUrl(),
  }),
  tagTypes,
  endpoints: () => ({}),
});

export default baseApi;
